<script lang="ts">
  import { Select } from '@shared/ui/fields/select';
  import { artworksSortOptions } from '../config';
  import type { SortOptionType } from '../types';

  export let field: string;
  export let order: string;

  let selectedSort: SortOptionType | undefined = artworksSortOptions[0];

  const handleChangeSort = (option: SortOptionType) => {
    field = option.value.column;
    order = option.value.order;
  };

  const handleChangeProps = (field: string, order: string) => {
    if (field && order) {
      // case when order and field are received from query params
      const option = artworksSortOptions.find((opt) => opt.value.column === field && opt.value.order === order);

      if (option) {
        selectedSort = option;
      }
    }
  };

  $: handleChangeProps(field, order);
</script>

<Select
  fieldClass="py-0"
  isNoBorder
  options="{artworksSortOptions}"
  selectedOption="{selectedSort}"
  containerClass="dark:bg-store-dark"
  on:change="{(e) => handleChangeSort(e.detail)}"
/>
